import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { Layout } from "@/components/Layout";
import { ProtectedRoute } from "@/components/ProtectedRoute";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Visit from "@/pages/Visit";
import Sermons from "@/pages/Sermons";
import Events from "@/pages/Events";
import Ministries from "@/pages/Ministries";
import Give from "@/pages/Give";
import Contact from "@/pages/Contact";
import Gallery from "@/pages/Gallery";
import BibleExplorer from "@/pages/BibleExplorer";
import AdminLogin from "@/pages/admin/Login";
import AdminDashboard from "@/pages/admin/Dashboard";

import "@/App.css";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-center" richColors />
        <Routes>
          <Route path="/" element={<Layout><Home /></Layout>} />
          <Route path="/about" element={<Layout><About /></Layout>} />
          <Route path="/visit" element={<Layout><Visit /></Layout>} />
          <Route path="/sermons" element={<Layout><Sermons /></Layout>} />
          <Route path="/events" element={<Layout><Events /></Layout>} />
          <Route path="/ministries" element={<Layout><Ministries /></Layout>} />
          <Route path="/give" element={<Layout><Give /></Layout>} />
          <Route path="/gallery" element={<Layout><Gallery /></Layout>} />
          <Route path="/explore" element={<Layout><BibleExplorer /></Layout>} />
          <Route path="/contact" element={<Layout><Contact /></Layout>} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
